const scratchCardEn = {
  'scratchCard': {
    'codeLabel': 'Code from scratch card',
    'description': 'Enter the code № {{codeNumber}} from your \nscratch card № {{card}}',
    'keysInformation': 'Number of keys available: {{availableKeysCount}}',
    'confirm': 'Confirm',
    'errors': {
      'scratch_card_code_invalid': 'Incorrectly entered code. Please check it and try again',
      'scratch_card_code_is_block': 'Code is blocked. Enter another one',
    },
  },
};

export default scratchCardEn;
